/** Faction key art (public/), shared by the menu's faction cards and the
 *  post-game summary's winner banner. */
import type { FactionId } from '../sim';

export const FACTION_ART: Record<FactionId, string> = {
  hyperscale: '/faction-hyperscale.jpeg',
  serverless: '/faction-serverless.jpeg',
  openweights: '/faction-openweights.jpeg',
};
